import React, { useEffect, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useStockOutAndInListModel } from "../stockOutAndInListModel";
import { IStockBorrowDetail } from "../stockOutAndInListType";
import { momentFormat } from "@/utils/utils";
import { tableSize } from "@/utils/constants";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";
export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, reset
    } = useStockOutAndInListModel();
    const { technicianData } = useGlobalModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    useEffect(() => {
        loadData().then();
    }, [])

    const columns: ColumnsType<IStockBorrowDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 120,
            render: (t, r, i) => i + 1
        }, {
            title: '借件单号',
            width: 160,
            dataIndex: 'borrowCode',
            // render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onLook(text)}>{text}</p></Tooltip>,
        }, {
            title: '借件人',
            width: 160,
            dataIndex: 'borrowPerson',
            render: (text: string) => technicianData.find((ele: any) => ele.code === text)?.name ?? text
            // }, { 
            //     title: '单据类型',
            //     width: 160,
            //     dataIndex: 'documentType',
            // }, {
            //     title: '单据状态',
            //     width: 160,
            //     dataIndex: 'status',
            //     render: (text) => getTreeNodeName(text)
        }, {
            title: '制单人',
            width: 160,
            dataIndex: 'createUser',

        }, {
            title: '借件时间',
            width: 160,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '还件时间',
            width: 160,
            dataIndex: 'returnTime',
            render: (text) => momentFormat(text)
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockBorrow", "roleCodes": roles };
        return getRoleColumns("stockBorrow", "主单", columns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            size={tableSize}
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "checkbox",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IStockBorrowDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: () => onRow(record.id as string),
                    onContextMenu: (e) => {
                        e.preventDefault();
                        setSelectedRowKeys([record.id as string]);
                    }
                };
            }}
            scroll={{ x: 'max-content', y: 'calc(100vh - 340px)' }}
        />
    )
}
